module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12ByTzB/tc-custom/9798889108283.jpg?1726274071853",
      "alt": "This image is the cover for the book The Scars We Bear"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Scars We Bear\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Two teenagers, two tales interwoven by a shared intrigue. Their distinct temperaments guide them along separate paths through a demanding chapter of youthful existence. As they confront adversities both solo and side by side, the longing for independence dances a delicate duet with the need for connection. "), _c('em', [_vm._v("The Scars We Bear")]), _vm._v(" delves into the tumultuous journey of adolescence, exploring what it truly demands not merely to navigate through it, but to flourish with resilience and newfound wisdom. Through trials and triumphs, our young protagonists unveil the essence of camaraderie and the indomitable spirit of youth in facing life’s early storms.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kirk Shamley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0mm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Kirk Shamley is an average guy forever in search of a good story. He lives with his wife and cat while braving the wind-swept plains of Wyoming.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0